import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AnimatedFlowSection from './components/AnimatedFlowSection';
import ProcessStepsSection from './components/ProcessStepsSection';
import DisclaimerSection from './components/DisclaimerSection';
import FooterSection from '../HomePage/components/FooterSection';
import Navigation from '../../components/ui/Navigation';
import LanguageToggle from '../../components/ui/LanguageToggle';
import Button from '../../components/ui/Button';

const HowItWorksPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('EN');
  const navigate = useNavigate();

  // Initialize language from localStorage
  useEffect(() => {
    const savedLanguage = localStorage.getItem('creditFixerLanguage');
    if (savedLanguage && (savedLanguage === 'EN' || savedLanguage === 'FR')) {
      setCurrentLanguage(savedLanguage);
    }

    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  const content = {
    EN: {
      title: "How PSPXpress Works",
      subtitle: "A simple path to building your credit history",
      getStarted: "Get Started Now"
    },
    FR: {
      title: "Comment fonctionne PSPXpress",
      subtitle: "Un chemin simple pour construire votre historique de crédit",
      getStarted: "Commencer maintenant"
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <div className="min-h-screen bg-background">
      {/* Language Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageToggle 
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Navigation */}
      <Navigation currentLanguage={currentLanguage} />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-primary to-blue-800">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {text?.title}
          </h1>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            {text?.subtitle}
          </p>
          <Button
            variant="default"
            size="lg"
            onClick={() => navigate('/apply')}
            className="bg-white text-primary hover:bg-gray-50 font-semibold px-8 py-4 text-lg"
            iconName="ArrowRight"
            iconPosition="right"
          >
            {text?.getStarted}
          </Button>
        </div>
      </section>

      {/* Animated Flow Section */}
      <AnimatedFlowSection currentLanguage={currentLanguage} />

      {/* Process Steps */}
      <ProcessStepsSection currentLanguage={currentLanguage} />

      {/* Disclaimer */}
      <DisclaimerSection currentLanguage={currentLanguage} />

      {/* Footer */}
      <FooterSection currentLanguage={currentLanguage} />
    </div>
  );
};

export default HowItWorksPage;